import { Button } from 'util/ui'
import { getTimestampDisplayString } from 'util/date'
import { propFunc } from 'util/functions'
import themeVars from 'ui_theme/site/globals/site.variables'
import List from '../shared/List'
import ContentCard from '../shared/ContentCard'

const Subscriptions = ({ subscriptions, onUnsubscribe }) => (
  <div>
    {subscriptions.map(
      ({
        list_name: listName,
        list_id: listId,
        subscribed_at: subscriptionTime,
      }) => (
        <ContentCard title={listName} key={listId}>
          <List.Container>
            {subscriptionTime && (
              <List.Item label="Subscribed">
                {getTimestampDisplayString(subscriptionTime)}
              </List.Item>
            )}
          </List.Container>
          <Button
            size="medium"
            color={themeVars.berryColorName}
            onClick={propFunc(onUnsubscribe, listId)}
          >
            Remove from list
          </Button>
        </ContentCard>
      )
    )}
  </div>
)

export default Subscriptions
